import { render } from "./SkeletonServicesList.vue?vue&type=template&id=33ca78ca&scoped=true"
import script from "./SkeletonServicesList.vue?vue&type=script&lang=js"
export * from "./SkeletonServicesList.vue?vue&type=script&lang=js"

import "./SkeletonServicesList.vue?vue&type=style&index=0&id=33ca78ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33ca78ca"
/* hot reload */
if (module.hot) {
  script.__hmrId = "33ca78ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33ca78ca', script)) {
    api.reload('33ca78ca', script)
  }
  
  module.hot.accept("./SkeletonServicesList.vue?vue&type=template&id=33ca78ca&scoped=true", () => {
    api.rerender('33ca78ca', render)
  })

}

script.__file = "src/ui/skeleton/services/SkeletonServicesList.vue"

export default script